import axios from "axios";
import store from "@/store";
import moment from "moment";
import BrandKey from "@/assets/json/logbrand";
import VueCookies from "vue-cookies";
import { appConfig } from "@/aLwAJXh7rUuwykLl";

class ActivityLogger {
  constructor() {
    this.queue = [];
    this.flushInterval = 15000; // 15 วินาที
    this.batchSize = 15;
    this.isInitialized = false;
    this.startFlushing();
    this.setupUnloadListener();
  }

  logPageView(pageName, path, params = {}) {
    this.queue.push({
      type: "page_view",
      pageName: pageName || path,
      path,
      params,
      timestamp: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    });

    if (this.queue.length >= this.batchSize) {
      this.flush();
    }
  }

  flush() {
    if (this.queue.length === 0) return;

    const payload = this.queue.splice(0);
    this.sendWithKeepalive(payload);
  }
  getMemberId() {
    // ต้อง check store เตรียมพร้อม
    if (!store.state.shortProfile) return "";

    if (store.state.shortProfile.member_id) {
      return store.state.shortProfile.member_id;
    }

    if (store.state.shortProfile.user_guid) {
      return store.state.shortProfile.user_guid;
    }

    try {
      if (VueCookies.isKey("user_profile_token")) {
        let token = VueCookies.get("user_profile_token");
        // Parse ถ้าเป็น string
        if (typeof token === "string") {
          token = JSON.parse(token);
        }
        if (token && token.userId) {
          return token.userId;
        }
      }
    } catch (error) {
      console.error("Error getting memberId from cookie:", error);
    }

    return "";
  }

  getUserGUID() {
    // ลองเอาจาก store ก่อน
    if (store.state.shortProfile && store.state.shortProfile.user_guid) {
      return store.state.shortProfile.user_guid;
    }

    // ถ้าไม่มี ลองเอาจาก user_guid
    return "";
  }

  sendWithKeepalive(payload) {
    try {
      let location = window.location.hostname;
      let brand = location.split("-")[0];
      const key = BrandKey.find(el => el.brand.toLowerCase() == brand);

      // ส่งแต่ละ activity ทีละตัว (backend รับ JSON object เดี่ยว)
      payload.forEach(activity => {
        const log = {
          LogLevelId: 5, // Info level
          Menu: activity.path.replace("/", " ").trim(),
          Action: `Page View: ${activity.pageName}`,
          DeviceOS: window.navigator.platform,
          DeviceType: window.navigator.userAgent,
          UserGUID: this.getUserGUID(),
          Method: "PAGE_VIEW",
          Url: activity.path,
          ResponseCode: 200,
          Body: JSON.stringify({
            ...activity.params,
            member_id: this.getMemberId()
          }),
          ResponseBody: "",
          RequestTime: activity.timestamp,
          ResponseTime: "0",
          Note: "Automatic page view logging"
        };

        // ใช้ fetch กับ keepalive: true
        // ยิงต่อเนื่องแม้ว่า page ปิด/reload
        fetch(`${appConfig.VUE_APP_LOGGER_API}/Log`, {
          method: "POST",
          keepalive: true,
          headers: {
            "Content-Type": "application/json",
            "api-key": key ? key.key : "Cmd9Fk3QosXlakF0gMkeQ9fASogF"
          },
          body: JSON.stringify(log)
        }).catch(error => {
          console.error("Activity logging failed:", error);
        });
      });
    } catch (error) {
      console.error("Activity logger error:", error);
    }
  }

  startFlushing() {
    setInterval(() => this.flush(), this.flushInterval);
  }

  setupUnloadListener() {
    // ยิงทันที่ก่อนปิด page
    window.addEventListener("beforeunload", () => {
      if (this.queue.length > 0) {
        this.flush();
      }
    });

    // สำรอง: ใช้ pagehide ด้วย
    window.addEventListener("pagehide", () => {
      if (this.queue.length > 0) {
        this.flush();
      }
    });
  }
}

export const activityLogger = new ActivityLogger();
